<template>
  <CriterionItem
    :criterion="source"
    :formula="formula"
    @onTagClick="$emit('onTagClick', $event)"
  />
</template>

<script>
import CriterionItem from './CriterionItem.vue'

export default {
    props: {
        source: {
            default: () => ({}),
            type: Object,
        },

        formula: {
            type: Object,
            required: true
        },
    },

    components: {
        CriterionItem,
    },
}
</script>
